// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"61da5a27","427":"34295753","472":"9ec0760e","653":"6b9fa64b","867":"b8c53be3","940":"3f9423c8","960":"64d0314e"}[chunkId] + ".chunk.css";
};